import axios from 'axios'
import Config from '@/settings'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API, // api 的 base_url
  // baseURL: process.env.VUE_APP_ENV_URL,
  timeout: Config.timeout, // 请求超时时间
  checkToken: true
})
// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['appKey'] = Config.appKey
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status
    if (code < 200 || code > 300) {
      // Notification.error({
      //   title: response.message
      // })
      console.log(response.message)
      return Promise.reject('error')
    } else {
      console.log('response.data',response.data)
      const success = response.data.success;
      if (!success) {
        console.log(response.data.errorMsg)
        return Promise.reject('error')
      } else {
        return response.data
      }
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.data.status || error.response.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        // Notification.error({
        //   title: '网络请求超时',
        //   duration: 5000
        // })
        console.log(response.message)
        return Promise.reject(error)
      }
    }
    if (code) {
      const errorMsg = error.response.data.message
      if (errorMsg !== undefined) {
        // Notification.error({
        //   title: errorMsg,
        //   duration: 5000
        // })
        console.log(response.message)
      }
    } else {
      // Notification.error({
      //   title: '接口请求失败',
      //   duration: 5000
      // })
      console.log(response.message)
    }
    return Promise.reject(error)
  }
)
export default service
